// extracted by mini-css-extract-plugin
module.exports = {"dark":"SearchPage_dark__YUm3J"};